var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('img',{staticClass:"href",attrs:{"src":_vm.href,"alt":""}}),_c('img',{staticClass:"icon",attrs:{"src":_vm.changan,"alt":""}}),_c('p',[_vm._v("长按识别二维码跳转至公众号")])])}
var staticRenderFns = []

export { render, staticRenderFns }